import { createAsyncThunk} from '@reduxjs/toolkit';
import { siteDataService } from '../../services/siteDataService'

export const siteDataThunk = createAsyncThunk(
    'siteData/homeData',
    async (data, {rejectWithValue}) => {
      try {
        const req = await siteDataService();
        if (req.success === false) { 
           return rejectWithValue(req)
         }
        return req;
      } catch (e) {
        return rejectWithValue(e)
      }
    }
  );
  